import {logger} from './AppUtil';

export const SPLUNK_LABELS = {
    METRIC: {
        LOAD_TIME_APP_CHUNK: 'LOAD_TIME_APP_CHUNK',
        LOAD_TIME_SIGN_IN_CHUNK: 'LOAD_TIME_SIGN_IN_CHUNK',
        LOAD_TIME_ELEVATE_CHUNK: 'LOAD_TIME_ELEVATE_CHUNK',
        LOAD_TIME_SIGN_UP_CHUNK: 'LOAD_TIME_SIGN_UP_CHUNK',
        LOAD_TIME_FORGOT_PW_CHUNK: 'LOAD_TIME_FORGOT_PW_CHUNK',
        LOAD_TIME_RESET_PW_CHUNK: 'LOAD_TIME_RESET_PW_CHUNK',
        LOAD_TIME_CHANGE_PW_CHUNK: 'LOAD_TIME_CHANGE_PW_CHUNK',
        LOAD_TIME_LOGOUT_CHUNK: 'LOAD_TIME_LOGOUT_CHUNK',
        LOAD_TIME_CCPA_CHUNK: 'LOAD_TIME_CCPA_CHUNK',
        LOAD_TIME_PROFILE_CHUNK: 'LOAD_TIME_PROFILE_CHUNK',
        LOAD_TIME_MIGRATE_CHUNK: 'LOAD_TIME_MIGRATE_MAIN_CHUNK'
    }
};

/**
 * Helper function for dealing with logging chunk load times
 */
export function resetLoadTimeOfChunk() {
    window.sflySsoStartTime = Date.now();
}

/**
 * Helper function for dealing with logging chunk load times
 */
export function logLoadTimeOfChunk(splunkLabel) {
    logger.metric({
        appContext: {
            splunkLabel,
            timeTaken: Date.now() - window.sflySsoStartTime
        }
    });
        
}